import React from 'react';
import { useDispatch } from 'react-redux';
import * as actions from '../../store/senderBuild/actions';

export function useSetDefaultZoom(args: { isFullScreen: boolean; isSmallScreen: boolean }) {
  const { isFullScreen, isSmallScreen } = args;
  const dispatch = useDispatch();

  const setZoom = React.useCallback(() => {
    if (isFullScreen && !isSmallScreen) {
      dispatch(actions.setZoom(1.5));
    } else if (isSmallScreen) {
      dispatch(actions.setZoom(0.6));
    } else {
      dispatch(actions.setZoom(1.25));
    }
  }, [isFullScreen, isSmallScreen, dispatch]);

  return setZoom;
}
